import type { ReactNode } from "react";

import { useLocalization } from "@fluent/react";

import PanelRow from "./PanelRow";
import styles from "./TaxonomySelectPanelRow.module.scss";

import type { TransactionCategory } from "../../hooks/useTransactionCategories";

// TaxonomySelectPanelRow.module.scss keys a z-index fix off this literal.
export const PANEL_TAXONOMY_SELECT_ID_PREFIX = "panel-taxonomy-select-";

interface TaxonomySelectPanelRowProps {
  categories: TransactionCategory[];
  canWrite: boolean;
  labelId: string;
  rowTestId: string;
  textTestId: string;
  select: ReactNode;
  text: string;
}

const TaxonomySelectPanelRow = ({
  categories,
  canWrite,
  labelId,
  rowTestId,
  textTestId,
  select,
  text,
}: TaxonomySelectPanelRowProps) => {
  const { l10n } = useLocalization();

  return (
    <PanelRow label={l10n.getString(labelId)} testId={rowTestId}>
      <div className={styles.control}>
        {/* An empty taxonomy means the request is in flight or has failed, and it is not retried. */}
        {canWrite && categories.length > 0 ? (
          select
        ) : (
          <span className={styles.text} data-testid={textTestId}>
            {text}
          </span>
        )}
      </div>
    </PanelRow>
  );
};

export default TaxonomySelectPanelRow;
